// These methods belong to every table view with pagination

export default {
  data() {
    return {
      page: {
        limit: this.limit >= 0 ? this.limit : 20,
        total: 0,
        from: 0,
        to: 0,
        offset: 0,
        current: 1,
      },
    };
  },
  watch: {
    limit(newValue) {
      this.page.limit = newValue;
    },
  },
  methods: {
    pagination(info) {
      const parts = info.split("/");
      this.page.total = parseInt(parts[1], 10);
      const limits = parts[0].split("-");
      this.page.from = parseInt(limits[0], 10);
      this.page.to = parseInt(limits[1], 10);
    },
    changePage(n) {
      this.page.current = n;
      this.page.offset = this.page.limit * (n - 1);
      this.load();
    },
    changeLimit(size) {
      if (size !== null || size !== undefined) {
        this.page.limit = size;
        this.load();
      }
    },
  },
};
